import { message } from 'antd';

class Deletes {
  parent = null;

  constructor(props) {
    this.parent = props;
  }

  clearRectColor = () => {
    this.parent.store.setRectColor('');
  };

  removeCompany = (groupId, companyId) => {
    const group = this.parent.getGroup(groupId);

    if (group) {
      group.delete.removeCompany(companyId);
    } else {
      // message.error('沒有找到 group');
    }
  };

  removeBoothNumber = (groupId) => {
    const group = this.parent.getGroup(groupId);

    if (group) {
      group.delete.removeBoothNumber(groupId);
    } else {
      // message.error('沒有找到 group');
    }
  };

  removeMarkIcon = (groupId) => {
    const group = this.parent.getGroup(groupId);

    if (group) {
      group.delete.removeMarkIcon();
    } else {
      // message.error('沒有找到 group');
    }
  };

  removeMarkText = (groupId) => {
    const group = this.parent.getGroup(groupId);

    if (group) {
      group.delete.removeMarkText();
    } else {
      // message.error('沒有找到 group');
    }
  };

  removeMark = (groupId) => {
    const group = this.parent.getGroup(groupId);

    if (group) {
      group.delete.removeMark();
    } else {
      // message.error('沒有找到 group');
    }
  };

  removeAreaName = (groupId) => {
    const group = this.parent.getGroup(groupId);

    if (group) {
      group.delete.removeAreaName();
    } else {
      // message.error('沒有找到 group');
    }
  };
}

export default Deletes;
